<template>
  <div>
    <Header page="manager_file"/>
    <div class="detailUser container detailFile">
      <Breadcrumb/>
      <div id="detailUser-main">
        <b-row class="">
          <b-col cols="12" lg="3">
            <div class="infoDetailUser">
              <div class="avatar avatar-detail">
                <img :src="editFileDetail.icon_url" alt class="avt-modal" />
              </div>
              <div class="text-center afterAvt">
                <h2 class="nameUser">{{truncate(editFileDetail.name,15,'...')}}</h2>
                <p class="department">{{convertSize(editFileDetail.size)}}</p>
              </div>
              <div class="text-left second-box">
                <div class="info-table">
                  <span class="label">作成者</span>
                  <span class="value id">{{editFileDetail.author}}</span>
                </div>
                <div class="info-table">
                  <span class="label">作成日</span>
                  <span class="value phone">{{dateFormat(editFileDetail.updated_time)}}</span>
                </div>
                <div class="info-table info-table-hashtag" v-show="editFileDetail.tags && editFileDetail.tags.length > 0">
                  <span class="label">タグ</span>
                  <span class="d-flex flex-wrap">
                    <span class="hashtag-name" v-for="(tag,index) in editFileDetail.tags" v-bind:key="index">{{tag.name}}</span>
                  </span>
                </div>
                <div class="info-table">
                  <span class="label">説明</span>
                  <span class="email line-3">{{editFileDetail.description}}</span>
                </div>
              </div>
              <div class="text-center button-box">
                <button class="btn btn-edit btn-rounder w-100 mw-253" @click="showModalEdit">
                  <i class="icon-i-edit"></i>
                  <span>編集</span>
                </button>
                <button class="btn btn-second btn-rounder w-100 mw-253" @click="showModalDelete">削除</button>
              </div>
            </div>
          </b-col>
          <b-col cols="12" lg="1" class="border-relative">
            <span class="borderLeft-pt"></span>
          </b-col>
          <b-col cols="12" lg="8">
            <div class="table-responsive scroll-bar list-files-table list-file-right table-fileDetail">
              <table class="table table-csHistory table-mb-pd table-e-mb">
                <thead>
                  <tr>
                    <th scope="col" class="wi-50 mb-w-45">名前</th>
                    <th scope="col" class="text-center wi-25">観覧回数</th>
                    <th scope="col" class="text-center wi-25 mb-w-30">最終観覧日</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="tableInfo" v-for="(logFile,index) in logFiles" v-bind:key="index">
                    <td scope="row" class="table-role wi-50 mb-w-45">
                      <div class="tableInfo--box">
                        <div class="thumbnail">
                          <img :src="logFile.avatar" alt class="img-preview" />
                        </div>
                        <div class="info">
                          <h4 class="name-file">{{truncate(logFile.employee_name,10,'...')}}</h4>
                          <span class="date">コード: {{truncate(logFile.employee_code,10,'...')}}</span>
                        </div>
                      </div>
                    </td>
                    <td class="table-view text-center wi-25 table-role">{{logFile.total_views}}</td>
                    <td class="table-lastview text-center wi-25 table-role mb-w-30">{{dateFormat(logFile.last_date)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ModalFileEdit />
            <ModalFileDelete />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/share/Header'
import HistoryView from '@/components/share/HistoryView'
import Breadcrumb from '@/views/Manager/FolderManager/Breadcrumb'
import ModalFileEdit from '@/components/Manager/FolderManagerment/FileEdit'
import ModalFileDelete from '@/components/Manager/FolderManagerment/FileDelete'
import {mapState} from 'vuex'
export default {
  name: 'DetailFile',
  components: {
    Header,
    HistoryView,
    Breadcrumb,
    ModalFileEdit,
    ModalFileDelete
  },
  data () {
    return {

    }
  },
  methods: {
    showModalDelete () {
      this.$store.dispatch('managerFolder/detailFile', {id: this.$route.params.id})
      this.$root.$emit('bv::show::modal', 'modalFileDelete', '#modalFileDelete')
    },
    showModalEdit () {
      this.$store.dispatch('managerFolder/getTag')
      this.$store.dispatch('managerFolder/detailFile', {id: this.$route.params.id})
      this.$root.$emit('bv::show::modal', 'modalFileEdit', '#modalFileEdit')
    }
  },
  computed: {
    ...mapState({
      editFileDetail: state => state.managerFolder.editFileDetail,
      logFiles: state => state.managerFolder.logFiles
    })
  },
  mounted () {
    this.$store.dispatch('managerFolder/detailFile', {id: this.$route.params.id})
    this.$store.dispatch('managerFolder/logFile', {id: this.$route.params.id, page_index: 1})
  }
}
</script>
<style scoped lang='scss'>
@import '@/assets/stylesheet/user/detail_user.scss';
@import '@/assets/stylesheet/auth/listfile.scss';
@import "@/assets/stylesheet/auth/historyview.scss";
@import "@/assets/stylesheet/user/list_user.scss";
</style>



// WEBPACK FOOTER //
// src/views/Manager/FolderManager/FileDetail.vue